export default {
  admin: "Admin",
  member: "Member",
  organization: "Organization",
  updateMember: "Update Member",
  deactivateMember: "Deactivate",
  reactivateMember: "Reactivate",
  changeRoleToMember: "Change Role to Member",
  changeRoleToAdmin: "Change Role to Admin",
  changeRoleToOwner: "Change Role to Owner",
  activeTeamMembers: "Active Team Members ({{count}})",
  deactivated: "Deactivated Team Members ({{count}})",
  teamMemberDeleted: "Team member deactivated",
  deactivateMemberTitle: "Deactivate team member",
  deactivateMemberMessage:
    "Are you sure you want to deactivate {{name}}? They will lose access to the organization. You can reactivate them later.",
  scheduleSettings: "Schedule Settings",
  timezone: "Timezone",
  workingDays: "Working Days",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  scheduleSettingsUpdated: "Schedule settings updated successfully",
  atLeastOneWorkingDay: "At least one working day must be selected",
  contributor: "Contributor",
  addTeamMember: "Add Team Member",
  addTeamMemberMenu: "Add Team Member Menu",
  addContributor: "Add Contributor",
  addContributorDescription:
    "Add a contributor to your team. Contributors are managed via Slack and do not need to log in.",
  editContributor: "Edit Contributor",
  deleteContributor: "Delete Contributor",
  deleteContributorConfirm:
    "This will permanently remove the contributor and all their time entries. This action cannot be undone.",
  deleteConfirmPhrase: "DELETE",
  deleteContributorTypePrompt: "Type {{phrase}} to confirm.",
  deleteContributorTypeMismatch: "The confirmation phrase does not match.",
  contributorCreatedSuccess:
    "Contributor added. They'll be matched to Slack on next sync.",
  contributorUpdatedSuccess: "Contributor updated successfully.",
  contributorDeletedSuccess: "Contributor removed successfully.",
  slackMatched: "Matched",
  slackMatchedTooltip: "This contributor is linked to a Slack account.",
  slackUnmatched: "Unmatched",
  slackUnmatchedTooltip:
    "This contributor has not been matched to a Slack account yet. They will be matched automatically on the next sync.",
  addAnother: "Add another",
  emailChangeSlackNote:
    "Changing the email may require Slack to re-sync the mapping.",
  hourlyRate: "Hourly Rate",
  costRate: "Cost Rate",
  readOnlyNotice:
    "You're viewing these settings in read-only mode. Contact your organization admin to make changes.",
  editRate: "Edit Rate",
  editTeamMember: "Edit Team Member",
  rateUpdatedSuccess: "Rate updated successfully.",
  teamMemberUpdatedSuccess: "Team member updated successfully.",
  owner: "Owner",
  editMember: {
    ownerTransferWarning:
      "You will become an admin in {{organization}}. This action is immediate.",
    ownerTransferTypeNamePrompt: "Type {{name}} to confirm.",
    ownerTransferNameMismatch: "The confirmation name does not match.",
    transferOwnership: "Transfer ownership",
    ownerTransferSuccess: "Ownership transferred to {{name}}.",
  },
  invitations: {
    heading: "Invitations",
    invitedAt: "Invited at",
    inviter: "Invited by",
    selectAll: "Select all invitations on this page",
    selectRow: "Select invitation for {{email}}",
    deleteSelected: "Delete {{count}} invitations",
    pageOf: "Page {{current}} of {{total}}",
    previous: "Previous",
    next: "Next",
    filter: {
      all: "All",
      pending: "Pending",
      expired: "Expired",
      accepted: "Accepted",
      declined: "Declined",
      cancelled: "Cancelled",
    },
    statusLabel: {
      pending: "Pending",
      expired: "Expired",
      accepted: "Accepted",
      declined: "Declined",
      cancelled: "Cancelled",
    },
    actions: {
      menuLabel: "Invitation actions for {{email}}",
      resend: "Resend",
      changeRole: "Change role",
      cancel: "Cancel",
      delete: "Delete",
    },
    changeRole: {
      title: "Change invitation role",
      description: "Pick a new role for the invitation to {{email}}.",
      submit: "Update role",
      successToast: "Invitation role updated.",
    },
    empty: {
      pending: "No pending invitations.",
      expired: "No expired invitations.",
      accepted: "No accepted invitations.",
      declined: "No declined invitations.",
      cancelled: "No cancelled invitations.",
    },
    emptyAll: "No invitations yet.",
    cancelTitle: "Cancel invitation",
    cancelMessage:
      "Cancel the invitation to {{email}}? They will no longer be able to accept it.",
    confirmCancel: "Cancel invitation",
    deleteTitle: "Delete invitation",
    deleteMessage: "Delete the invitation to {{email}}? This cannot be undone.",
    bulkDeleteTitle: "Delete invitations",
    bulkDeleteMessage: "Delete {{count}} invitations? This cannot be undone.",
    confirmDelete: "Delete",
  },
  roles: {
    groupSystem: "System",
    groupCustom: "Custom",
    pageTitle: "Roles",
    pageDescription:
      "Roles define what your team members can do. System roles are built in; create custom roles to fine-tune access.",
    createButton: "Create role",
    createButtonDisabledTooltip: "Upgrade to Pro to create custom roles.",
    columnName: "Name",
    columnMembers: "Members",
    columnSystem: "Type",
    columnDescription: "Description",
    systemTooltip: "System role — can't be edited or deleted.",
    customBadge: "Custom",
    upgradeCardHeadline: "Create custom roles",
    upgradeCardBody:
      "Define roles with granular permissions tailored to how your team works. Available on the Pro plan.",
    upgradeCardCta: "Upgrade to Pro",
    rowEditAction: "Edit role",
    rowDeleteAction: "Delete role",
    loading: "Loading roles…",
    emptyTitle: "No roles yet",
    emptyMessage: "Create a custom role to get started.",
    deleteModalTitle: "Delete role",
    deleteModalMessage: "Delete the {{name}} role? This cannot be undone.",
    deleteConfirmButton: "Delete",
    blockedModalTitle: "Role in use",
    blockedModalMessage:
      "The {{name}} role is assigned to {{memberCount}} team member(s) and {{invitationCount}} pending invitation(s). Reassign them before deleting.",
    blockedModalCta: "Go to team page",
    form: {
      createTitle: "Create role",
      editTitle: "Edit role",
      back: "Back",
      nameLabel: "Name",
      namePlaceholder: "e.g. Billing Manager",
      descriptionLabel: "Description",
      descriptionPlaceholder: "What is this role for?",
      permissionsLabel: "Permissions",
      permissionsHelp:
        "Choose what members with this role can do. Selecting an action automatically grants the matching view access.",
      selectedCounter: "{{selected}} of {{total}} selected",
      atLeastOne: "Select at least one permission.",
      loading: "Loading permissions…",
      createSubmit: "Create role",
      editSubmit: "Save changes",
      createSuccess: "Role created.",
      updateSuccess: "Role updated.",
    },
  },
  notifications: {
    title: "Notification routing",
    description:
      "Choose who receives each notification from invup about this organization. Leave a rule blank to use the default; the organization owner and admins.",
    save: "Save changes",
    cancel: "Cancel",
    saved: "Notification routing saved",
    addEmailPlaceholder: "Add an email…",
    defaultBadge: "Defaults to owner + admins",
    footerNote: "Press Enter or comma to add each recipient.",
    invalidEmail: "Enter a valid email address.",
    duplicate: "“{{email}}” is already a recipient.",
    duplicateNotificationType:
      "Each notification can only be configured once per organization.",
    groups: {
      invoices: "Invoices",
      payments: "Payments",
      forms: "Forms",
    },
    types: {
      invoice_sent: {
        label: "Invoice sent",
        description:
          "When an invoice is sent to a client (manual or scheduled).",
      },
      invoice_paid: {
        label: "Invoice paid",
        description:
          "When a client pays an invoice and a transaction is recorded.",
      },
      recurring_invoice_created: {
        label: "Recurring invoice created",
        description:
          "When a new invoice is generated from a recurring schedule.",
      },
      contract_invoice_generated: {
        label: "Contract invoice generated",
        description:
          "When an invoice is generated from a contract's payment schedule.",
      },
      transaction_receipt: {
        label: "Transaction receipt",
        description: "Cc'd on the receipt email when a client pays an invoice.",
      },
      form_submitted: {
        label: "Form response submitted",
        description: "When a client submits a response to one of your forms.",
      },
    },
  },
};
